import { Card, CardContent } from "@/components/ui/card";
import { AverageTicketData, DashboardFilters } from "@/types/dashboard";
import { Mask } from "@/utils/mask";
import { Receipt } from "lucide-react";

interface AverageTicketCardProps {
  data: AverageTicketData;
  period?: DashboardFilters["period"];
}

const periodLabels: Record<string, string> = {
  today: "Hoje",
  yesterday: "Ontem",
  week: "Semana",
  month: "Mês",
  custom: "Período",
};

export function AverageTicketCard({ data, period = "today" }: AverageTicketCardProps) {
  const periodLabel = periodLabels[period || "today"] || "Hoje";

  return (
    <Card className="h-full border-0 shadow-lg bg-gradient-to-br from-rose-400 via-rose-500 to-pink-600 text-white">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="p-2 bg-white/20 backdrop-blur rounded-lg">
            <Receipt className="h-4 w-4" />
          </div>
          <span className="font-medium">Ticket Médio</span>
        </div>

        <p className="text-3xl font-bold mb-1">
          {Mask.formatCurrency(data.current)}
        </p>
        <p className="text-rose-200 text-sm">{periodLabel}</p>

        <div className="mt-4 pt-3 border-t border-white/20">
          <div className="flex items-center justify-between">
            <span className="text-rose-200 text-sm">Média mensal</span>
            <span className="font-semibold">{Mask.formatCurrency(data.monthly)}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
